import React from "react";
import { TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";

interface Option {
    value: any;
    label: string;
}

interface SearchableSelectProps {
    label?: string;
    options: Option[];
    value?: any;
    onChange: (value: any) => void;
    multiple?: boolean;
    disabled?: boolean;
    required?: boolean;
    disableClearable?: boolean;
    style?: React.CSSProperties;
    variant?: "standard" | "outlined" | "filled";
}

// 全站共用的可搜尋下拉：值進出皆為原始 value（多選為 value 陣列），內部反查 {value,label} 選項
export default ({
    label,
    options,
    value,
    onChange,
    multiple,
    disabled,
    required,
    disableClearable,
    style,
    variant = "standard",
}: SearchableSelectProps) => {
    const opts = options ?? [];
    const selected = multiple
        ? (Array.isArray(value) ? value : []).map(
              (v) => opts.find((o) => o.value === v) ?? { value: v, label: String(v) }
          )
        : opts.find((o) => o.value === value) ?? null;
    return (
        <Autocomplete
            multiple={multiple}
            options={opts}
            value={selected}
            disabled={disabled}
            disableClearable={disableClearable}
            noOptionsText="無符合結果"
            style={style}
            getOptionLabel={(option: any) => option?.label ?? ""}
            getOptionSelected={(option: any, val: any) =>
                option?.value === (val?.value ?? val)
            }
            onChange={(_, option: any) => {
                if (multiple) {
                    onChange(((option ?? []) as any[]).map((o) => o?.value ?? o));
                } else {
                    onChange(option ? option.value : null);
                }
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    placeholder={label}
                    required={required}
                    variant={variant as any}
                />
            )}
        />
    );
};
